import { render, staticRenderFns } from "./PaperSizeComp.vue?vue&type=template&id=69ca59a2&scoped=true&"
import script from "./PaperSizeComp.vue?vue&type=script&lang=ts&"
export * from "./PaperSizeComp.vue?vue&type=script&lang=ts&"
import style0 from "./PaperSizeComp.vue?vue&type=style&index=0&id=69ca59a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca59a2",
  null
  
)

export default component.exports